<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <div class="row" v-if="customerId || ($store.state.userData.isOrganization && $store.state.role != 'branches')">
                <div class="col-12 mb-2" v-if="Object.keys(legalCustomerDetails).length">
                    <h5>اطلاعات سازمان</h5>
                    <div class="table-responsive">
                        <table class="table table-bordered table-hover user-details-table">
                            <tbody>
                                    <tr>
                                        <td>نام فارسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameFa }}</td>
                                        <td>نام انگلیسی:</td>
                                        <td>{{ legalCustomerDetails.companyNameEn }}</td>
                                        <td>شناسه ملی:</td>
                                        <td>{{ legalCustomerDetails.nationalId }}</td>
                                    </tr>
                                </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12">
                    <button v-if="currentAction == 0" class="btn btn-info" @click="downloadPersonnelsFile">دریافت لیست پرسنل</button>
                    <button v-else class="btn btn-info" @click="downloadPersonnelsFileUpdate">دریافت لیست پرسنل (جهت به روزرسانی)</button>
                    <hr>
                    <nav class="nav nav-tabs mb-3">
                        <a class="nav-link ml-1 active" @click="currentAction = 0" data-toggle="tab" href="#photos">ایجاد</a>
                        <a class="nav-link" @click="currentAction = 1" data-toggle="tab" href="#texts">به روزرسانی</a>
                    </nav>
                    <form class="row" v-on:submit.prevent="submitExcelFile">
                        <div class="col-md-4">
                            <label>انتخاب فایل پرسنل ها</label>
                            <div class="input-group file-browser">
                                <input type="text" class="form-control border-left-0 browse-file" id="input-pan" placeholder="آپلود فایل" readonly="">
                                <label class="input-group-btn mb-0">
                                    <span class="btn btn-primary">
                                        انتخاب کنید <input type="file" style="display: none;" accept=".xlsx" @input="setExcelFile">
                                    </span>
                                </label>
                            </div>
                            <p class="mt-3 mb-0" v-if="currentAction == 0">
                                <a href="#" @click="e => getExcelSample(e)">دریافت فایل نمونه</a>
                            </p>
                        </div>
                        <div class="col-md-12">
                            <button class="btn btn-success mt-3" v-if="file">ثبت اطلاعات</button>
                            <button class="btn btn-primary mt-3 ml-2 mr-2" v-if="resultFile" type="button" @click="getResultExcelFile">دریافت فایل نتیجه</button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-3">
                    <div class="form-group">
                        <label for="domain">سازمان</label>
                        <Vselect @input="searchCustomer" v-model="nationalCode" :reduce="item => item.nationalId" label="title" :options="organizations">
                            <div slot="no-options">مقداری یافت نشد</div>
                        </Vselect>
                    </div>
                </div>
                <div class="col-md-3">
                    <form v-on:submit.prevent="searchCustomer">
                        <label for="national-code">شناسه ملی</label>
                        <div class="input-group">
                            <input class="form-control text-left" maxlength="11" id="national-code" type="tel" v-model="nationalCode">
                            <span class="input-group-btn"><button class="btn ripple btn-primary" type="submit"><span class="input-group-btn"><i class="fa fa-search"></i></span></button></span>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { utils,writeFileXLSX } from 'xlsx';
export default {
    name: 'Personnel',
    data(){
        return {
            nationalCode: '',
            legalCustomerDetails: {},
            customerId: 0,
            showLoading: false,
            organizations: [],
            file: '',
            description: '',
            resultFile: '',
            currentAction: 0
        }
    },
    methods: {
        getData(){
            const postedData = {
                page: 1,
                perPage: 500
            };
            this.$api.post('Management/organizations/List',postedData).then(({data}) => {
                let organizations = [];
                data.result.list.map(item => {
                    if(item.domainMetaData)
                        organizations.push({
                            title: item.domainMetaData.companyNameFa,
                            nationalId: item.domainMetaData.nationalId
                        });
                });
                this.organizations = organizations;
            });
        },
        getResultExcelFile(){
            let a = window.document.createElement('a');
            a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + this.resultFile);
            let fileName = this.resultFile;
            a.setAttribute('download',fileName);
            window.document.body.appendChild(a);
            a.click();
            window.document.body.removeChild(a);
        },
        async toBase64(file){
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async setExcelFile(e){
            const file = e.target.files[0];
            const finalFile = await this.toBase64(file);
            this.file = finalFile;
            this.resultFile = '';
            document.getElementById('input-pan').setAttribute('placeholder',file.name);
        },
        searchCustomer(){
            this.legalCustomerDetails = {};
            const postedData = {
                company: true,
                nationalId: this.nationalCode
            };
            this.showLoading = true;
            this.$api.post('Management/Group/SearchCustomer',postedData).then(({data}) => {
                if(data.status){
                    this.legalCustomerDetails = data.result;
                }
                this.customerId = data.result.customerId;
                this.showLoading = false;
            }).finally(() => {
                this.showLoading = false;
            });
        },
        submitExcelFile(){
            this.showLoading = true;
            const postedData = {
                organizationId: this.customerId,
                file: this.file
            };
            let url = this.currentAction == 0 ? 'Organizations/Personnel/Sheet' : 'Organizations/Personnel/Sheet/Update';
            this.$api.post(url,postedData).then(({data}) => {
                this.resultFile = data.result ? data.result.file : '';
                if(data.status){
                    this.$swal({
                        title: 'تبریک',
                        icon: 'success',
                        text: 'اطلاعات پرسنل با موفقیت بارگذاری شدند',
                        confirmButtonText: 'متوجه شدم'
                    });
                    this.file = '';
                    document.getElementById('input-pan').setAttribute('placeholder','آپلود فایل');
                }else
                    this.$swal({
                        title: 'خطا',
                        icon: 'error',
                        text: 'آپلود فایل ناموفق بود',
                        confirmButtonText: 'متوجه شدم'
                    });
            }).finally(() => {
                this.showLoading = false;
            });
        },
        getExcelSample(e){
            e.preventDefault();
            this.$api.get('Organizations/Personnel/Sheet/Sample2').then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            });
        },
        downloadPersonnelsFile(){
            this.$api.get('Organizations/Personnel/Sheet/' + this.customerId).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            })
        },
        downloadPersonnelsFileUpdate(){
            this.$api.get('Organizations/Personnel/Sheet/Update/' + this.customerId).then(({data}) => {
                let a = window.document.createElement('a');
                a.setAttribute('href','https://cardapi.sabinarya.com/api/v1/Lookup/download/' + data.result);
                let fileName = data.result;
                a.setAttribute('download',fileName);
                window.document.body.appendChild(a);
                a.click();
                window.document.body.removeChild(a);
            })
        }
    },
    created(){
        if(this.$store.state.role != 'organization')
            this.getData();
    }
}
</script>